"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _APButton = _interopRequireDefault(require("../APButton"));
var _APIcon = _interopRequireDefault(require("../APIcon"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _history = _interopRequireDefault(require("../../../helpers/history"));
require("./Modal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClass = 'ap-modal';
var Modal = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Modal(props) {
    var _this;
    _classCallCheck(this, Modal);
    _this = _callSuper(this, Modal, [props]);
    _defineProperty(_this, "getBEMClasses", function () {
      return (0, _cssClassesHelper.getBEMClasses)(baseClass, _this.props.customClass);
    });
    _defineProperty(_this, "renderCloseIcon", function () {
      var bemClasses = _this.getBEMClasses();
      var onClick = _this.props.onCancel || _this.props.close;
      return /*#__PURE__*/_react["default"].createElement("div", {
        onClick: onClick,
        className: bemClasses('close-icon')
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "close",
        classModifiers: "big"
      }));
    });
    _defineProperty(_this, "handleFooterButtonClick", function (e) {
      _this.props.footer.onClick();
      !_this.props.footer.overrideClose && _this.props.close();
    });
    _this.modalRef = null;
    _this.unlisten = null;
    return _this;
  }
  _inherits(Modal, _React$Component);
  return _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      _reactModal["default"].setAppElement(this.modalRef);
      this.unlisten = _history["default"].listen(function (location, action) {
        var close = _this2.props.onCancel || _this2.props.close;
        if (action === 'POP' && _this2.props.isOpen) {
          close();
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unlisten();
      this.unlisten = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (!this.props.isOpen) return null;
      var bemClasses = this.getBEMClasses();
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(_ref) {
          return _this3.modalRef = _ref;
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
        className: bemClasses(),
        ariaHideApp: false,
        overlayClassName: bemClasses('overlay'),
        onRequestClose: this.props.onCancel || this.props.close,
        isOpen: this.props.isOpen
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('header')
      }, this.props.title), this.renderCloseIcon(), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('content')
      }, this.props.children), this.props.footer && /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('footer')
      }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        customClass: bemClasses(),
        onClick: this.handleFooterButtonClick,
        styleName: this.props.footer.buttonStyle,
        disabled: this.props.footer.disabled
      }, this.props.footer.buttonText))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Modal, "propTypes", {
  isOpen: _propTypes["default"].bool,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].func]),
  onCancel: _propTypes["default"].func,
  close: _propTypes["default"].func.isRequired,
  overrideClose: _propTypes["default"].bool,
  customClass: _propTypes["default"].string
});
_defineProperty(Modal, "defaultProps", {
  overrideClose: false
});